import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { textInCapitalCase } from '../../../../helpers/TextHelper';
import noPhoto from '../../../common/icons/defaultTicketProblem.jpg';
import { useTicketDetailStyles } from './styles';

const TicketDetail = ({ ...props }) => {
  const {
    thumbnailImage,
    name,
    ticketId,
    typeName,
    motiveName,
    index,
    mobile,
  } = props;

  const classes = useTicketDetailStyles({ mobile });
  return (
    <Box className={classes.ticketDetailContainer}>
      <Box>
        {!thumbnailImage && <Skeleton className={classes.skeleton} />}
        {thumbnailImage && (
          <img
            data-cy={`ticketImage-${index}`}
            src={thumbnailImage === 'no-photo' ? noPhoto : thumbnailImage}
            className={classes.image}
          />
        )}
      </Box>
      <Box>
        {name && (
          <Typography
            data-cy="productIssueTitle"
            className={`${classes.titleEmptyState} ${classes.text}`}
          >
            {textInCapitalCase(name)}
          </Typography>
        )}
        <Typography data-cy="issueNumber" className={classes.text}>
          <strong>Nº de solicitud:</strong> {ticketId}
        </Typography>
        <Typography data-cy="issueType" className={classes.text}>
          <strong>Tipo:</strong> {typeName}
        </Typography>
        <Typography data-cy="issueMotive" className={classes.text}>
          <strong>Motivo:</strong> {motiveName}
        </Typography>
      </Box>
    </Box>
  );
};

TicketDetail.propTypes = {
  thumbnailImage: PropTypes.string,
  name: PropTypes.string,
  ticketId: PropTypes.number,
  typeName: PropTypes.string,
  motiveName: PropTypes.string,
  index: PropTypes.number,
  mobile: PropTypes.bool,
};

export default TicketDetail;
